let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eUyOU")).then(() => parcelRequire('9rmw5'));